import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { SHARED_IMPORTS, SHARED_DECLARATIONS } from '../../Common/shared.config';
import { MAT_DIALOG_DATA, MatDialogRef } from '../../Common/modal-window/modal-window.service';
import { ModalWindowBaseComponent } from '../../Common/modal-window/modal-window-base.component';
import { RemoteCallCommonService, ICallParams } from '../../Common/remote-call-common.service';
import { InscripcionesService } from '../../Common/inscripciones.service';

@Component({
    selector: 'dialog-factura',
    templateUrl: './dialog-factura.component.html',
    styleUrls: [
        '../../Common/form.scss',
        './dialog-factura.component.scss'
    ],
    standalone: true,
    imports: [
      ...SHARED_IMPORTS, 
      ...SHARED_DECLARATIONS // Ahora esto funcionará correctamente
    ],
})
export class DialogFacturaComponent extends ModalWindowBaseComponent implements OnInit {
  public form_billing = new UntypedFormGroup({
      razon_social: new UntypedFormControl('',[Validators.required]),
      nif: new UntypedFormControl('',[Validators.required]),
      direccion: new UntypedFormControl('',[Validators.required]),
      codigo_postal: new UntypedFormControl('',[Validators.required]),
      persona: new UntypedFormControl('',[Validators.required]),
      telefono: new UntypedFormControl('',[Validators.required]),
      email: new UntypedFormControl('', [
          Validators.required,
          Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"),
      ]),

  });
  public sending_data = false;
  public send_data_error_msg = '';

  // ===========================================================================
  // ---------------------------------------------------------------------------
  constructor(
      private _RemoteCallCommonS: RemoteCallCommonService,
    //   public moda_window_ref: MatDialogRef<DialogFacturaComponent>,
      private _InscripcionesS: InscripcionesService,
      @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    super();

  }

  // ---------------------------------------------------------------------------
  get values(): any {

      return this.form_billing.value;

  }

  // ---------------------------------------------------------------------------
  ngOnInit(): void {

      this.sending_data = false;
      this.send_data_error_msg = '';

  }

  // ===========================================================================
  // ---------------------------------------------------------------------------
  public sendInfoFactura() {
      this.sending_data = true;
      this.send_data_error_msg = '';
      const dataIds = this._InscripcionesS.dataIdStored;
      const call_params:ICallParams = {
          accion: 'enviarMailFacturacion',
          argumentos: JSON.stringify(
            Object.assign({},
              this.values,
              {id: dataIds.id}
            )
          )
      };
      this._RemoteCallCommonS.sendJSONPost(call_params).subscribe(
          (response:any) => {
              if (response.error.codigo) {
                  this.send_data_error_msg = response.error.texto;
              } else {
                  this.close();
              }
              this.sending_data = false;
          },
          (e) => {
              this.sending_data = false;
              this.send_data_error_msg = e.error.text;
          },
      )

  }
}
